export { default } from './Icon';
export * from './types';
